import React, { useState, useEffect } from 'react'
import { sh, ReduxWrapper, compose } from 'common-data/datahelpers'
import { FAIcon, FileImg, Grid, GridCell, ToolTip } from 'common-controls/Core/index'
import _ from 'common-tools/LodashHelper'
import Skeleton from 'react-loading-skeleton'
import clsx from 'clsx'

export const ContentBoxedDisplayContext = React.createContext(
  {
    loading: false
  }
)

export const ContentBoxedDisplay = compose(
  ReduxWrapper([
    sh.SessionToken,
    sh.SessionAccount,
    sh.SessionUser
  ])
)(function BoxedContentDisplayPlain (props) {
  const { loading = false, titleActions, SessionAccount, SessionUser,
    children, title, titlePicture, SessionToken, type = 'agency' } = props

  const [titleButtons, setTitleButtons] = useState([])

  useEffect(() => {
    if (_.isArray(titleActions) === true && titleActions.length > 0) {
      const allowedTitleActions = _.filter(titleActions, (titleAction) => {
        if (_.isArray(titleAction.permissions)) {
          return SessionAccount.HasPermissions(titleAction.permissions) || SessionUser.HasPermissions(titleAction.permissions)
        } else {
          return true
        }
      })

      if (allowedTitleActions.length > 0) {
        setTitleButtons(
          _.map(allowedTitleActions, (a) => {
            const btn = <a className="grow" tabIndex="1" onClick={a.onClick}>
              <FAIcon name={a.icon} className="control-icon" />
            </a>

            if (a.toolTip) {
              return <li key={a.icon}><ToolTip placement='bottom' toolTip={a.toolTip} key={a.icon}>{btn}</ToolTip></li>
            } else {
              return <li key={a.icon}>{btn}</li>
            }
          })
        )
      } else {
        setTitleButtons([])
      }
    }
  }, [titleActions, SessionUser, SessionAccount])

  return (
    <ContentBoxedDisplayContext.Provider value={{ loading: loading }}>
      <Grid className={`profile-top-${type}`}>
        <GridCell className="text-center">
          {loading
            ? <div key='ploading' className="profile-name"><Skeleton /></div>
            : <div className="profile-name">{title}</div>
          }
        </GridCell>
        {titlePicture
          ? <div className={clsx(`profileCircle-${type}`, titlePicture.key && 'profileCircle-with-image')}>
            {titlePicture.key
              ? <FileImg className={`${type}-img`} pictureKey={titlePicture.key} SessionToken={SessionToken} />
              : <FAIcon name={titlePicture.icon} />}
          </div>
          : null
        }
      </Grid>
      {titleButtons.length > 0
        ? <div className='profile-control-panel'>
          <ul className="menu align-center">
            {titleButtons}
          </ul>
        </div>
        : null
      }
      <Grid className="profile-mid">
        <GridCell>
          {children}

        </GridCell>
      </Grid>
      <Grid className={`profile-btm-${type}`}>
        <GridCell>
          &nbsp;
        </GridCell>
      </Grid>
    </ContentBoxedDisplayContext.Provider>
  )
})
